import React from "react";

import styles from "./styles/PrimaryIcon.scss";
import { getStyledIconSrc } from "../../services/asset";

export interface PrimaryIconProps {
  className: string;
  handleFavorite: Function;
  ad: any;
}

const PrimaryIcon = (props: PrimaryIconProps) => {
  const { className, handleFavorite, ad } = props;
  const style = {
    backgroundImage: getStyledIconSrc(
      ad && ad.isFavorite ? "heart_chosen.svg" : "heart.svg"
    ),
  };

  return (
    <span
      role="button"
      tabIndex={0}
      className={`${className} ${styles.favoriteIcon}`}
      onClick={handleFavorite}
      style={style}
      // @ts-ignore
      alt={"Spremljeni oglasi"}
    />
  );
};

export default PrimaryIcon;



// WEBPACK FOOTER //
// ./src/containers/FavoriteButton/PrimaryIcon.tsx